module.exports = __webpack_public_path__ + "media/images/case-studies/longley-1f4e239d2191948fb7e9be2131348848.png";